"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHeading = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "GroupHeading");
const GroupHeading = ({ children }) => {
    return (React.createElement("div", { className: css("") },
        React.createElement("h3", null, children)));
};
exports.GroupHeading = GroupHeading;
//# sourceMappingURL=index.js.map